<script lang="ts">
    import { _ } from "svelte-i18n"
    import { currentLang, location, currentProjects, currentColorTheme } from "../../store"
    import { navigate } from "svelte-routing"

    import Image from "../widgets/Image.svelte"
    import Video from "../widgets/Video.svelte"
    import ProjectPlansSlider from "../widgets/ProjectPlansSlider.svelte"
    import ContentBuilder from "../widgets/ContentBuilder.svelte"
    import Header from "../widgets/Header.svelte"

    export let content: Content // Current page content

    const formatDate = (date) => {
        const event = new Date(date)
        return event.toLocaleDateString($currentLang, { year: "numeric", month: "2-digit" })
    }

    const backToOverview = () => {
        let urlParts = $location.path.split("/")
        urlParts.pop()
        navigate(urlParts.join("/"))
    }

    $: countMediaItems = content?.project?.media?.items.filter((item) => item.public).length
</script>

<Header type="{1}" />

{#if content}
    <main class="page {content?.type?.join(' ').toLowerCase()}">
        <section class="wm-container">
            <div class="back" on:click="{backToOverview}" on:keydown>
                <img
                    src="img/icons/bi_arrow-left{$currentColorTheme === 'dark' ? '-white' : ''}.svg"
                    alt="{$_('back')}"
                />
                <span>{$_("back")}</span>
            </div>

            {#if content?.project?.general?.title}
                <h1>{content.project.general.title}</h1>
            {/if}
            <div class="project-subheadline">
                {#if content?.project?.general?.category}
                    {#each Array.isArray(content.project.general.category) ? content.project.general.category : content.project.general.category.split(",") as cat}
                        <h2>{$_("project.categories." + cat.trim())}</h2>
                    {/each}
                {/if}
                {#if content?.project?.general?.date}
                    <div>{formatDate(content.project.general.date)}</div>
                {/if}
                {#if content?.project?.general?.shortDescription}
                    <div>{content.project.general.shortDescription}</div>
                {/if}
            </div>

            <div class="project-main-data" class:horizontal="{content?.project?.general?.mainDataHorizontal}">
                {#if content?.project?.media?.mainImage}
                    <Image
                        entryId="{content.id}"
                        file="{content.project.media?.mainImage}"
                        cssClass="project-main-image"
                        imageFilter="xl"
                    />
                {/if}

                <section class="project-meta-information">
                    <ProjectPlansSlider content="{content}" />

                    {#if content?.project?.general?.description}
                        <div class="project-description">
                            {@html content.project.general.description}
                        </div>
                    {/if}
                </section>
            </div>

            {#if content?.project?.media?.items.length && countMediaItems}
                <div class="wm-row project-media mt-xl">
                    {#each content?.project?.media?.items as item}
                        {#if item.public}
                            {#if item.leftOffsetColumnSize && item.leftOffsetColumnSize !== "0"}
                                <div class="wm-col-md-{item.leftOffsetColumnSize}"></div>
                            {/if}

                            <div class="wm-col-md-{item.columnSize}">
                                <div class="project-media-item {item.align ? 'text-align-' + item.align : ''}">
                                    {#if item.file || item.video}
                                        <div class="project-media-image">
                                            {#if item.imageOrVideo !== "video"}
                                                <Image entryId="{content.id}" file="{item.file}" imageFilter="xl" />
                                            {:else}
                                                <Video entryId="{content.id}" file="{item.video}" />
                                            {/if}

                                            {#if item.caption && item.caption !== ""}
                                                <div class="project-media-caption">
                                                    {item.caption}
                                                </div>
                                            {/if}
                                        </div>
                                    {/if}

                                    {#if item.description && item.description !== ""}
                                        <div class="project-media-description">
                                            {@html item.description}
                                        </div>
                                    {/if}
                                </div>
                            </div>
                        {/if}
                    {/each}
                </div>
            {/if}

            <!-- <ContentBuilder content="{content?.pageBuilder}" /> -->

            {#if content?.project?.general?.finalInformation}
                <section class="final-information">
                    {@html content.project.general.finalInformation}
                </section>
            {/if}
        </section>
    </main>

    {#each $currentProjects as project, index}
        {#if content.id === project.id && $currentProjects[index + 1]}
            <div class="to-next-project" on:click="{() => navigate($currentProjects[index + 1]?.path)}" on:keydown>
                <div class="wm-container">
                    <div class="next-project">{$_("next-project")}</div>
                    <div class="next-project-title">{$currentProjects[index + 1]?.project?.general?.title}</div>
                    <img src="img/icons/carbon_arrow-up-right.svg" alt="{$_('next-project')}" />
                </div>
            </div>
        {/if}
    {/each}
{/if}
